module.exports = __webpack_public_path__ + "static/media/344c428b-74f6-47bd-9182-2f80f95f4fc5.e106aca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/344c428b-74f6-47bd-9182-2f80f95f4fc5.png
// module id = 1451
// module chunks = 0